import { ACTION_TYPES } from './actionTypes';
import { getTools } from './tools';
import { useTranslation } from 'react-i18next';
export const getSampleWorkflows = () => {
    // Get translation function
    const { t, i18n } = useTranslation();
    const TOOLS = getTools();
    const /** Sample workflows */ SAMPLE_WORKFLOWS = [
        {
            category: 'Content / SEO',
            name: t('SEO Keywords Research & Analysis'),
            description: t('Expand from 1 seed keywords to 100+'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    promptContent: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    inputs: [
                        {
                            name: 'SEED KEYWORD',
                            description: t('The target keyword'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `You are a professional SEO marketer.

Based on the seed keyword, generate a comprehensive list of related keyword ideas. Consider different variations, long-tail keywords, synonyms, and related concepts.
          
Aim for at least 100 unique keyword ideas. Output in a table format.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Cluster all the keywords into relevant group, and suggest potential search intents (informational, transactional, navigational) for each keyword. `,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Plan a complete SEO content strategy and calendar based on all the related keywords.
          
In the calendar, please only the following columns:
          
Cluster | Target Keywords | Types | Priority |
          
Types could be Listicles, How-To Guides, Problem–Solution Posts, Compare and Contrast Posts, Definitive Guides, Thought Leadership, Checklist and/or Template, ""What"", ""Why"" and Case Studies.
Explain your strategy on why.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'PR / Communication',
            name: t('Staged Questions for Seminar Q&A'),
            description: t('Prepare Q&A session for webinars'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'AUDIENCE',
                            description: t('The department & role'),
                            value: '',
                            type: 'text',
                        },
                        {
                            name: 'OBJECTIVE',
                            description: t('The objective of webinar'),
                            value: '',
                            type: 'text',
                        },
                        {
                            name: 'THEME',
                            description: t('The key talking point'),
                            value: '',
                            type: 'text',
                        },
                    ]
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Play a role as a Marketing Event Coordinator/Manager.
          
Generate a list of questions tailored to each audience segment.
          
Focus on the key information you want to convey or promote to the audience to guide question formation.
          
Aim to craft each question with distinct goals in mind.
          
Keep questions concise, as audiences typically prefer short queries during seminars.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Assess each question to ensure it serves its intended purpose and revise if necessary.
          
Envision what the ideal response to each question would be.
          
Determine the outcomes you expect from the responses.
          
Ensure questions highlight your products and benefits, reinforce your brand's credibility, and emphasize the speaker’s expertise and experience.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Choose 5 questions that align with the specific objectives of the event the best, such as:
Accelerating the sales pipeline.
Building brand awareness and enhancing thought leadership.
Promoting products and their business benefits.
Providing guidance on maximizing the use of the product for clients.
Keep questions concise, as audiences typically prefer short queries during seminars. 
Output in a table format.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Email Marketing',
            name: t('Webinar Promotion Emails'),
            description: t('Create a series of webinar emails'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'BRIEF',
                            description: t('The webinar brief'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `You are an experienced marketing copywriter who specializes in writing compelling webinar announcement emails.
          
Write the initial webinar announcement email copy based on the webinar brief provided. Make sure to highlight the key benefits and create a compelling call-to-action. Return only the email copy, nothing else.
          
Please follow this structure:
          
[Attention-grabbing subject line]
          
[Introduction paragraph highlighting the topic and key benefits]
          
[Main section with details on the webinar content, speaker(s), time and date]
          
[Call-to-action to register for the webinar]
          
[Conclusion re-stating the key benefits]`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write the 1st reminder (7 days away) email copy for this webinar based on the brief provided. Make sure to re-highlight the key benefits and compel the reader to register. Return only the email copy, nothing else.
          
Your webinar reminder emails follow this structure:
          
[Attention-grabbing subject line]
          
[Opening paragraph utilizing the pain-agitate-solution copywriting framework]
          
[Details on time, date and registration link]
          
[Call-to-action to register for the webinar]
          
[Conclusion re-highlighting the key benefits]`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write the 2nd reminder (3 days away) email copy for this webinar based on the brief provided. Make sure to re-highlight the key future state and compel the reader to register. Return only the email copy, nothing else.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write an urgent, compelling ""last chance"" email for this webinar. Use the webinar brief to highlight key benefits and create urgency to register immediately. Return only the email copy, nothing else.
          
Your last chance webinar emails follow this structure:
          
[Urgent subject line]
          
[Opening paragraph reiterating key benefits and limited remaining spots]
          
[Details on time, date and registration link]
          
[Final call-to-action to register immediately]
          
[Conclusion re-stating key benefits]`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Email Marketing',
            name: t('Webinar Follow Up Emails'),
            description: t('Create a series of webinar follow-up emails'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'TRANSCRIPT',
                            description: t('The webinar transcript'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a concise webinar summary focusing on the key learnings from the webinar transcript provided.
          
Your webinar summaries follow this structure:
          
[1-2 sentence overview of webinar topic]
          
[Bulleted list of 3-5 key learnings from the webinar]
          
[1-2 closing sentences]`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `You are an email marketing specialist skilled at writing warm and engaging thank you emails.
          
Write a warm and personal thank you email for webinar attendees. Incorporate the webinar summary provided above. Only return the email.
          
Your thank you emails have this structure:
          
[Personalized greeting]
          
[Express appreciation for attending]
          
[1-2 sentence webinar summary]
          
[Share any additional resources or takeaways]
          
[Closing statement]`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a personalized and engaging follow-up email for non-attendees of the webinar, incorporating the webinar summary and replay link provided. Only return the email.
          
Your follow-up emails have this structure:
          
[Personalized greeting]
          
[Note they missed the live webinar]
          
[1-2 sentence webinar summary]
          
[Mention webinar was recorded and provide replay link]
          
[Closing statement]`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Social',
            name: t('Write LinkedIn Posts'),
            description: t('Create LinkedIn posts from a brief'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'BRIEF',
                            description: t('The topic or brief of the post'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `You are a LinkedIn post writer. Your job is to write compelling posts that get engagement. 
          
Write a compelling LinkedIn post about this topic following the AIDA (Attention, Interest, Desire, Action) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the BISCUIT (Brief, Interest, Story, Conclusion, Unique, Invitation, Target) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the PAS (Problem, Agitate, Solve) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the ACCA (Awareness, Comprehension, Conviction, Action) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the QUEST (Question, Unique, Explain, Story, Tie-back) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the Star-Chain-Hook formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the SLAP (Startling Fact, Link to Audience, Application, Punchline) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Write a compelling LinkedIn post about this topic following the BAB (Before, After, Bridge) formula.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Sales',
            name: t('Research Company'),
            description: t('Research Company description'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'TARGET COMPANY',
                            description: t('Name or Domain'),
                            value: '',
                            type: 'text',
                        },
                        {
                            name: 'COMPANY COUNTRY',
                            description: t('Location'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.webSearch.value,
                    description: '',
                    promptContent: `# Role:
As a Sales Intelligence Analyst, research <target company> in <company country>. 

Keep <target company> exactly as it is together with <company country> when you use any tool.

# Task:
Your task is to compile comprehensive intelligence report on target company to support strategic sales outreach.

## The report should include:

1. Company Overview:
- What they do, their industry and founding years
- Business model
- Product and services

2. Company Metrics:
- Revenue
- Employees count

3. Funding / acquisition:
- Type of funding and the amount

## Format:
- Use headers
- Include sources
- Use tables/bullets where helpful

## Remember:
Use multiple sources for each section. 
Be sure to cross check for facts. 
Make sure to search from most recent data.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.webSearch.value,
                    description: '',
                    promptContent: `Extract the details into table format including the following columns:

Industry | Employee Count | Revenue | Business Model | Product/Service | Funding Type | Funding Amount`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Sales',
            name: t('Find Company Job Openings'),
            description: t('Find Company Job Openings description'),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.googleSearchResults.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'COMPANY DOMAIN',
                            description: t('The URL of the company'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.googleSearchResults.value,
                    description: '',
                    promptContent: `Return up to 5 URLs that include the job openings/career of the company domain. `,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `# Task: 
Your objective is to find as much job openings as possible.

Crawl the URLs and return the detailed position of all the job openings. 

## Output Format:
In a table with the column Job Position Title | Department | Job Description

## If there is no jobs openings available:
Return that there are no jobs opening found.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `# Task: 
Your job is to analyze the open jobs of a company.

## If there are open jobs:
Brainstorm the top 3 focus areas/growth areas of the company.   

Afterwards, infer the top 3 issues or problems the company most likely faces. 
Be specific and use simple words to explain.

## If there are no job openings:
Return that you cannot conduct analysis because there are no jobs openings.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Content / SEO',
            name: t('Create SEO blog from 1 keyword'),
            description: t(`Create SEO blog from 1 keyword description`),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'TARGET KEYWORD',
                            description: t('The Target Keyword'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.googleSearchResults.value,
                    description: '',
                    promptContent: `Return a table with Position, Title, Snippets, URL.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `Analyze the URL content. Return a table with Sources | Type | Content Direction | Key info or data.

For the Type, identify whether it is branded promotional materials or a blog post. If it is a blog post, identify which type it is: 

- Listicles 
- How-to guides 
- Problem–solution posts 
- Compare and contrast posts 
- Definitive guides to… 
- Thought leadership posts 
- Checklists and/or templates 
- “What” posts 
- “Why” posts 
- Case Studies  

For the key info or data, try to preserve as much content as possible.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `# Task:
As a professional SEO content creator, you will select the most strategic URLs (Max 5 URLs) and develop a unified content direction & content brief that will outperform them.

## 1. Provide the reasons why you select these URLs

## 2. Create a content brief that includes:
- SEO-optimized title (include target keyword, must be less than 50 characters, use simple words) 
- 3-5 target keyword clusters 
- Content structure with H2/H3 outline
- Target Audience
- Recommended word count and blog post type  

### Remember:
Do not Include Case studies / success stories`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `# Task:
Create a comprehensive 1200-word article based on the provided SEO-optimized content brief.

The article should effectively incorporate the following elements: 
- Key themes identified in the brief 
- Enrich content with reference URLs. 
- Use natural anchor text/hyperlinks that flows seamlessly within the sentences

## Introduction (100 words): 
- Open with a provocative question related to the main topic 
- Present a false dichotomy, then challenge it to grab the reader's attention 
- Use casual, conversational language to connect with the audience 
- Promise to debunk conventional wisdom on the topic 
- Clearly state the value proposition for the reader - Employ a "problem-solution" framework to set up the rest of the article  

## Body (900 words): 
- Divide the content into 3-4 main sections, each addressing a key theme from the brief 
- Use subheadings within each section to further organize the information 
- Incorporate relevant keywords naturally throughout the text 
- Provide in-depth explanations, examples, and practical tips
- Address common questions or concerns the target audience might have  

## Conclusion - "Final Thoughts" (100 words): 
- Summarize the main points discussed in the article 
- Reinforce the value proposition and key takeaways 
- Do not ask audience to read more in other sources  

### SEO and Readability Requirements: 
- Ensure the content enhances search engine visibility while maintaining readability 
- Use simple language appropriate for the target audience 
- Vary sentence structure to maintain reader interest

### Article Structure and Content Requirements: 
- Craft an engaging and informative piece with a logical structure 
- Use clear headings and subheadings to organize the content
- Incorporate tables and lists where appropriate to enhance readability 
- Include relevant statistics and data to support your points 
- Maintain a consistent tone throughout the article that resonates with the target audience `,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Sales',
            name: t('Cold Email Outreach'),
            description: t(`Create personalised outreach emails based on the prospect linkedin and your company.`),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'PROSPECT LINKEDIN URL',
                            description: t('Prospect Linkedin'),
                            value: '',
                            type: 'text',
                        },
                        {
                            name: 'YOUR COMPANY NAME',
                            description: t('Your company name'),
                            value: '',
                            type: 'text',
                        },
                        {
                            name: 'YOUR COMPANY USP',
                            description: t('Your unique selling point'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.crawlLinkedinProfile.value,
                    description: '',
                    promptContent: `Prepare the prospect report with the following:

# Prospect full name
# Current working company name
# Current working role
# Previous working experience table:
- All Previous working company name, role and duration
# Languages
# Education table:
- All previous school name, degree name and duration
# Latest posts/news/achievements

Return the prospect report only.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.googleSearchResults.value,
                    description: '',
                    promptContent: `Find out the current company domain of the prospect. 

Return the company domain only.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.findEmail.value,
                    description: '',
                    promptContent: `Find out the prospect email address. 

Return the prospect email only.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
                {
                    type: ACTION_TYPES.PROMPT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: `# Role:
You are a sales outreach expert working for <YOUR COMPANY>. The unique selling point is <YOUR COMPANY USP>.

# Task:
Draft a personalised cold email outreach to the prospect.

## Email Subject (40 - 50 characters):
Use the format: [Prospect Company Name] <> [Your Company Name]: [a brief phrase or word that provides additional context or relevance to the email]

## Email Body (150 words):
- Start with a highly specific detail from their recent activity.
- State how USP can help the prospect. Use bullets to get across the point quickly. 
- Max 3-4 bullet points.
- End with a One clear, low-commitment ask Call-to-action.

## Writing Style:
- Conversational tone
- Use simple words`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
        {
            category: 'Sales',
            name: t('Find Company Emails'),
            description: t(`Given a company name or domain, it will find out working emails of a company.`),
            actions: [
                {
                    type: ACTION_TYPES.INPUT,
                    name: '',
                    tool: TOOLS.crawlWebpage.value,
                    description: '',
                    promptContent: '',
                    inputs: [
                        {
                            name: 'TARGET COMPANY',
                            description: t('Name or Domain'),
                            value: '',
                            type: 'text',
                        }
                    ]
                },
                {
                    type: ACTION_TYPES.TOOL,
                    name: '',
                    tool: TOOLS.findCompanyEmails.value,
                    description: '',
                    promptContent: `Find out the email address of the target company.

Return the emails in a table format.`,
                    inputs: [{
                            name: '',
                            description: '',
                            value: '',
                            type: 'text',
                        },],
                },
            ],
            author: 'Studio Global',
        },
    ];
    return SAMPLE_WORKFLOWS;
};
